// Exercise Bank Data
// All exercises with icons and videos for the ACL Care platform
// Thumbnails are from YouTube (always public) instead of Google Drive

export const exerciseBankData = [
  {
    id: 'ex-001',
    name: '1-leg hamstring bridge slides (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/_PGKsplAEG8/mqdefault.jpg',
    videoUrl: 'https://youtu.be/_PGKsplAEG8',
    videoEmbedUrl: 'https://www.youtube.com/embed/_PGKsplAEG8',
  },
  {
    id: 'ex-002',
    name: '2 leg vertical to 1 leg land',
    iconUrl: 'https://img.youtube.com/vi/Lflj6050dT4/mqdefault.jpg',
    videoUrl: 'https://youtu.be/Lflj6050dT4',
    videoEmbedUrl: 'https://www.youtube.com/embed/Lflj6050dT4',
  },
  {
    id: 'ex-003',
    name: '3-way toe taps (with band)',
    iconUrl: 'https://img.youtube.com/vi/f3xyquQazKE/mqdefault.jpg',
    videoUrl: 'https://youtu.be/f3xyquQazKE',
    videoEmbedUrl: 'https://www.youtube.com/embed/f3xyquQazKE',
  },
  {
    id: 'ex-004',
    name: 'Banded side steps (3 levels)',
    iconUrl: 'https://img.youtube.com/vi/t7anZkBnLLM/mqdefault.jpg',
    videoUrl: 'https://youtu.be/t7anZkBnLLM',
    videoEmbedUrl: 'https://www.youtube.com/embed/t7anZkBnLLM',
  },
  {
    id: 'ex-005',
    name: 'Bear crawl iso holds',
    iconUrl: 'https://img.youtube.com/vi/bXbyIXavcEI/mqdefault.jpg',
    videoUrl: 'https://youtu.be/bXbyIXavcEI',
    videoEmbedUrl: 'https://www.youtube.com/embed/bXbyIXavcEI',
  },
  {
    id: 'ex-006',
    name: 'Bird dog',
    iconUrl: 'https://img.youtube.com/vi/hjoQMjYJO8o/mqdefault.jpg',
    videoUrl: 'https://youtu.be/hjoQMjYJO8o',
    videoEmbedUrl: 'https://www.youtube.com/embed/hjoQMjYJO8o',
  },
  {
    id: 'ex-007',
    name: 'Clamshell raises (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/b7Q8TdvAON0/mqdefault.jpg',
    videoUrl: 'https://youtu.be/b7Q8TdvAON0',
    videoEmbedUrl: 'https://www.youtube.com/embed/b7Q8TdvAON0',
  },
  {
    id: 'ex-008',
    name: 'Copenhagen plank (4 levels)',
    iconUrl: 'https://img.youtube.com/vi/iV6E9DMWE5Q/mqdefault.jpg',
    videoUrl: 'https://youtu.be/iV6E9DMWE5Q',
    videoEmbedUrl: 'https://www.youtube.com/embed/iV6E9DMWE5Q',
  },
  {
    id: 'ex-009',
    name: 'Dead bugs (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/xrqdT4fgeh8/mqdefault.jpg',
    videoUrl: 'https://youtu.be/xrqdT4fgeh8',
    videoEmbedUrl: 'https://www.youtube.com/embed/xrqdT4fgeh8',
  },
  {
    id: 'ex-010',
    name: 'Drop landing plyos (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/l5cLA0Z0zY4/mqdefault.jpg',
    videoUrl: 'https://youtu.be/l5cLA0Z0zY4',
    videoEmbedUrl: 'https://www.youtube.com/embed/l5cLA0Z0zY4',
  },
  {
    id: 'ex-011',
    name: 'Goblet squat w/foot elevated',
    iconUrl: 'https://img.youtube.com/vi/nu30G5bZ8Aw/mqdefault.jpg',
    videoUrl: 'https://youtu.be/nu30G5bZ8Aw',
    videoEmbedUrl: 'https://www.youtube.com/embed/nu30G5bZ8Aw',
  },
  {
    id: 'ex-012',
    name: 'Hamstring bridge march',
    iconUrl: 'https://img.youtube.com/vi/wIvaoVdpbtk/mqdefault.jpg',
    videoUrl: 'https://youtu.be/wIvaoVdpbtk',
    videoEmbedUrl: 'https://www.youtube.com/embed/wIvaoVdpbtk',
  },
  {
    id: 'ex-013',
    name: 'Hamstring bridge slides (3 levels)',
    iconUrl: 'https://img.youtube.com/vi/OEsC8gstwZI/mqdefault.jpg',
    videoUrl: 'https://youtu.be/OEsC8gstwZI',
    videoEmbedUrl: 'https://www.youtube.com/embed/OEsC8gstwZI',
  },
  {
    id: 'ex-014',
    name: 'Hip thrust march',
    iconUrl: 'https://img.youtube.com/vi/Ch80hbFOUa8/mqdefault.jpg',
    videoUrl: 'https://youtu.be/Ch80hbFOUa8',
    videoEmbedUrl: 'https://www.youtube.com/embed/Ch80hbFOUa8',
  },
  {
    id: 'ex-015',
    name: 'Ladder drills (Phase 1)',
    iconUrl: 'https://img.youtube.com/vi/tHpzKnAXhOo/mqdefault.jpg',
    videoUrl: 'https://youtu.be/tHpzKnAXhOo',
    videoEmbedUrl: 'https://www.youtube.com/embed/tHpzKnAXhOo',
  },
  {
    id: 'ex-016',
    name: 'Ladder drills (Phase 2)',
    iconUrl: 'https://img.youtube.com/vi/B17taqJ169M/mqdefault.jpg',
    videoUrl: 'https://youtu.be/B17taqJ169M',
    videoEmbedUrl: 'https://www.youtube.com/embed/B17taqJ169M',
  },
  {
    id: 'ex-017',
    name: 'Ladder drills (Phase 3)',
    iconUrl: 'https://img.youtube.com/vi/2xZ_TgWrgL8/mqdefault.jpg',
    videoUrl: 'https://youtu.be/2xZ_TgWrgL8',
    videoEmbedUrl: 'https://www.youtube.com/embed/2xZ_TgWrgL8',
  },
  {
    id: 'ex-018',
    name: 'Ladder drills (Phase 4)',
    iconUrl: 'https://img.youtube.com/vi/s-RaVyb-wRI/mqdefault.jpg',
    videoUrl: 'https://youtu.be/s-RaVyb-wRI',
    videoEmbedUrl: 'https://www.youtube.com/embed/s-RaVyb-wRI',
  },
  {
    id: 'ex-019',
    name: 'Landing control (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/cHodnby4UDw/mqdefault.jpg',
    videoUrl: 'https://youtu.be/cHodnby4UDw',
    videoEmbedUrl: 'https://www.youtube.com/embed/cHodnby4UDw',
  },
  {
    id: 'ex-020',
    name: 'Lateral box jumps',
    iconUrl: 'https://img.youtube.com/vi/lxXaN61KBnw/mqdefault.jpg',
    videoUrl: 'https://youtu.be/lxXaN61KBnw',
    videoEmbedUrl: 'https://www.youtube.com/embed/lxXaN61KBnw',
  },
  {
    id: 'ex-021',
    name: 'Lateral high knees w/controlled landing',
    iconUrl: 'https://img.youtube.com/vi/pZH-o0L9msA/mqdefault.jpg',
    videoUrl: 'https://youtu.be/pZH-o0L9msA',
    videoEmbedUrl: 'https://www.youtube.com/embed/pZH-o0L9msA',
  },
  {
    id: 'ex-022',
    name: 'Lateral hip plyos (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/8T4499F9l9o/mqdefault.jpg',
    videoUrl: 'https://youtu.be/8T4499F9l9o',
    videoEmbedUrl: 'https://www.youtube.com/embed/8T4499F9l9o',
  },
  {
    id: 'ex-023',
    name: 'Lateral low hurdle jumps',
    iconUrl: 'https://img.youtube.com/vi/DDU-VTrEeLM/mqdefault.jpg',
    videoUrl: 'https://youtu.be/DDU-VTrEeLM',
    videoEmbedUrl: 'https://www.youtube.com/embed/DDU-VTrEeLM',
  },
  {
    id: 'ex-024',
    name: 'Lateral step-down',
    iconUrl: 'https://img.youtube.com/vi/xpEWSla4iWU/mqdefault.jpg',
    videoUrl: 'https://youtu.be/xpEWSla4iWU',
    videoEmbedUrl: 'https://www.youtube.com/embed/xpEWSla4iWU',
  },
  {
    id: 'ex-025',
    name: 'Linear low hurdle jumps',
    iconUrl: 'https://img.youtube.com/vi/Jun87oULvYw/mqdefault.jpg',
    videoUrl: 'https://youtu.be/Jun87oULvYw',
    videoEmbedUrl: 'https://www.youtube.com/embed/Jun87oULvYw',
  },
  {
    id: 'ex-026',
    name: 'Medial hops (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/63-GRBXnDf0/mqdefault.jpg',
    videoUrl: 'https://youtu.be/63-GRBXnDf0',
    videoEmbedUrl: 'https://www.youtube.com/embed/63-GRBXnDf0',
  },
  {
    id: 'ex-027',
    name: 'Multi-plane hops & Skater squat',
    iconUrl: 'https://img.youtube.com/vi/IBSqY-PcQZA/mqdefault.jpg',
    videoUrl: 'https://youtu.be/IBSqY-PcQZA',
    videoEmbedUrl: 'https://www.youtube.com/embed/IBSqY-PcQZA',
  },
  {
    id: 'ex-028',
    name: 'Nordic quads',
    iconUrl: 'https://img.youtube.com/vi/dXqzHcCIPK0/mqdefault.jpg',
    videoUrl: 'https://youtu.be/dXqzHcCIPK0',
    videoEmbedUrl: 'https://www.youtube.com/embed/dXqzHcCIPK0',
  },
  {
    id: 'ex-029',
    name: 'Pike leg extension (3 levels)',
    iconUrl: 'https://img.youtube.com/vi/c3mumvnK03g/mqdefault.jpg',
    videoUrl: 'https://youtu.be/c3mumvnK03g',
    videoEmbedUrl: 'https://www.youtube.com/embed/c3mumvnK03g',
  },
  {
    id: 'ex-030',
    name: 'Plank shoulder taps',
    iconUrl: 'https://img.youtube.com/vi/ufUsvBl_Yns/mqdefault.jpg',
    videoUrl: 'https://youtu.be/ufUsvBl_Yns',
    videoEmbedUrl: 'https://www.youtube.com/embed/ufUsvBl_Yns',
  },
  {
    id: 'ex-031',
    name: 'Plank walk-out',
    iconUrl: 'https://img.youtube.com/vi/syPv5Ct3tOI/mqdefault.jpg',
    videoUrl: 'https://youtu.be/syPv5Ct3tOI',
    videoEmbedUrl: 'https://www.youtube.com/embed/syPv5Ct3tOI',
  },
  {
    id: 'ex-032',
    name: 'Pogo jumps (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/aldpySaxRik/mqdefault.jpg',
    videoUrl: 'https://youtu.be/aldpySaxRik',
    videoEmbedUrl: 'https://www.youtube.com/embed/aldpySaxRik',
  },
  {
    id: 'ex-033',
    name: 'Rear foot elevated split squat',
    iconUrl: 'https://img.youtube.com/vi/JlmxFAa4hPs/mqdefault.jpg',
    videoUrl: 'https://youtu.be/JlmxFAa4hPs',
    videoEmbedUrl: 'https://www.youtube.com/embed/JlmxFAa4hPs',
  },
  {
    id: 'ex-034',
    name: 'Rear foot elevated split squat jumps (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/oxsQoqDG-Yk/mqdefault.jpg',
    videoUrl: 'https://youtu.be/oxsQoqDG-Yk',
    videoEmbedUrl: 'https://www.youtube.com/embed/oxsQoqDG-Yk',
  },
  {
    id: 'ex-035',
    name: 'Reverse crunches',
    iconUrl: 'https://img.youtube.com/vi/-rWVWCD1TvE/mqdefault.jpg',
    videoUrl: 'https://youtu.be/-rWVWCD1TvE',
    videoEmbedUrl: 'https://www.youtube.com/embed/-rWVWCD1TvE',
  },
  {
    id: 'ex-036',
    name: 'Rotational box jumps (90°)',
    iconUrl: 'https://img.youtube.com/vi/d2phA5erK4Y/mqdefault.jpg',
    videoUrl: 'https://youtu.be/d2phA5erK4Y',
    videoEmbedUrl: 'https://www.youtube.com/embed/d2phA5erK4Y',
  },
  {
    id: 'ex-037',
    name: 'Side lunges (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/bb5-IRXSVwI/mqdefault.jpg',
    videoUrl: 'https://youtu.be/bb5-IRXSVwI',
    videoEmbedUrl: 'https://www.youtube.com/embed/bb5-IRXSVwI',
  },
  {
    id: 'ex-038',
    name: 'Side planking (Phase 1) (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/kM1vRAik6VY/mqdefault.jpg',
    videoUrl: 'https://youtu.be/kM1vRAik6VY',
    videoEmbedUrl: 'https://www.youtube.com/embed/kM1vRAik6VY',
  },
  {
    id: 'ex-039',
    name: 'Side planking (Phase 2) (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/jEXw0lyha2A/mqdefault.jpg',
    videoUrl: 'https://youtu.be/jEXw0lyha2A',
    videoEmbedUrl: 'https://www.youtube.com/embed/jEXw0lyha2A',
  },
  {
    id: 'ex-040',
    name: 'Single-leg balance',
    iconUrl: 'https://img.youtube.com/vi/F-ZKf1unaU4/mqdefault.jpg',
    videoUrl: 'https://youtu.be/F-ZKf1unaU4',
    videoEmbedUrl: 'https://www.youtube.com/embed/F-ZKf1unaU4',
  },
  {
    id: 'ex-041',
    name: 'Single-leg calf raises',
    iconUrl: 'https://img.youtube.com/vi/9z81AzT-O0E/mqdefault.jpg',
    videoUrl: 'https://youtu.be/9z81AzT-O0E',
    videoEmbedUrl: 'https://www.youtube.com/embed/9z81AzT-O0E',
  },
  {
    id: 'ex-042',
    name: 'Single-leg crab bridge',
    iconUrl: 'https://img.youtube.com/vi/7kr8-snvSII/mqdefault.jpg',
    videoUrl: 'https://youtu.be/7kr8-snvSII',
    videoEmbedUrl: 'https://www.youtube.com/embed/7kr8-snvSII',
  },
  {
    id: 'ex-043',
    name: 'Single-leg glute bridge',
    iconUrl: 'https://img.youtube.com/vi/izR2-KK3vaA/mqdefault.jpg',
    videoUrl: 'https://youtu.be/izR2-KK3vaA',
    videoEmbedUrl: 'https://www.youtube.com/embed/izR2-KK3vaA',
  },
  {
    id: 'ex-044',
    name: 'Single-leg plyos (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/FVKYx0fPZYI/mqdefault.jpg',
    videoUrl: 'https://youtu.be/FVKYx0fPZYI',
    videoEmbedUrl: 'https://www.youtube.com/embed/FVKYx0fPZYI',
  },
  {
    id: 'ex-045',
    name: 'Single-leg RDL',
    iconUrl: 'https://img.youtube.com/vi/ldyTY54MwOg/mqdefault.jpg',
    videoUrl: 'https://youtu.be/ldyTY54MwOg',
    videoEmbedUrl: 'https://www.youtube.com/embed/ldyTY54MwOg',
  },
  {
    id: 'ex-046',
    name: 'Single-leg squat (self catch)',
    iconUrl: 'https://img.youtube.com/vi/UR2p3sOAOp0/mqdefault.jpg',
    videoUrl: 'https://youtu.be/UR2p3sOAOp0',
    videoEmbedUrl: 'https://www.youtube.com/embed/UR2p3sOAOp0',
  },
  {
    id: 'ex-047',
    name: 'Single-leg squat (vertical leg support)',
    iconUrl: 'https://img.youtube.com/vi/rxMqWBBLWqE/mqdefault.jpg',
    videoUrl: 'https://youtu.be/rxMqWBBLWqE',
    videoEmbedUrl: 'https://www.youtube.com/embed/rxMqWBBLWqE',
  },
  {
    id: 'ex-048',
    name: 'Single-leg squats to box (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/SrEufr7eFYM/mqdefault.jpg',
    videoUrl: 'https://youtu.be/SrEufr7eFYM',
    videoEmbedUrl: 'https://www.youtube.com/embed/SrEufr7eFYM',
  },
  {
    id: 'ex-049',
    name: 'Skater squat',
    iconUrl: 'https://img.youtube.com/vi/T8W5U9eYH9o/mqdefault.jpg',
    videoUrl: 'https://youtu.be/T8W5U9eYH9o',
    videoEmbedUrl: 'https://www.youtube.com/embed/T8W5U9eYH9o',
  },
  {
    id: 'ex-050',
    name: 'Split squat jump switches',
    iconUrl: 'https://img.youtube.com/vi/NLOR93USkBQ/mqdefault.jpg',
    videoUrl: 'https://youtu.be/NLOR93USkBQ',
    videoEmbedUrl: 'https://www.youtube.com/embed/NLOR93USkBQ',
  },
  {
    id: 'ex-051',
    name: 'Squat jumps',
    iconUrl: 'https://img.youtube.com/vi/soIQNQcPcrg/mqdefault.jpg',
    videoUrl: 'https://youtu.be/soIQNQcPcrg',
    videoEmbedUrl: 'https://www.youtube.com/embed/soIQNQcPcrg',
  },
  {
    id: 'ex-052',
    name: 'Sumo squats',
    iconUrl: 'https://img.youtube.com/vi/EQZN_zx0hf4/mqdefault.jpg',
    videoUrl: 'https://youtu.be/EQZN_zx0hf4',
    videoEmbedUrl: 'https://www.youtube.com/embed/EQZN_zx0hf4',
  },
  {
    id: 'ex-053',
    name: 'Superdog',
    iconUrl: 'https://img.youtube.com/vi/5YUCJMOYFaw/mqdefault.jpg',
    videoUrl: 'https://youtu.be/5YUCJMOYFaw',
    videoEmbedUrl: 'https://www.youtube.com/embed/5YUCJMOYFaw',
  },
  {
    id: 'ex-054',
    name: 'Superman raises (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/xAHE5fK2LZA/mqdefault.jpg',
    videoUrl: 'https://youtu.be/xAHE5fK2LZA',
    videoEmbedUrl: 'https://www.youtube.com/embed/xAHE5fK2LZA',
  },
  {
    id: 'ex-055',
    name: 'Toe drops',
    iconUrl: 'https://img.youtube.com/vi/Xnl9NsVA1mo/mqdefault.jpg',
    videoUrl: 'https://youtu.be/Xnl9NsVA1mo',
    videoEmbedUrl: 'https://www.youtube.com/embed/Xnl9NsVA1mo',
  },
  {
    id: 'ex-056',
    name: 'Toe walking',
    iconUrl: 'https://img.youtube.com/vi/OBW46fayOtE/mqdefault.jpg',
    videoUrl: 'https://youtu.be/OBW46fayOtE',
    videoEmbedUrl: 'https://www.youtube.com/embed/OBW46fayOtE',
  },
  {
    id: 'ex-057',
    name: 'Walking lunges (2 levels)',
    iconUrl: 'https://img.youtube.com/vi/t8MzqjEZd_8/mqdefault.jpg',
    videoUrl: 'https://youtu.be/t8MzqjEZd_8',
    videoEmbedUrl: 'https://www.youtube.com/embed/t8MzqjEZd_8',
  },
  {
    id: 'ex-058',
    name: 'Weighted wall sit',
    iconUrl: 'https://img.youtube.com/vi/lnkJhqipwaM/mqdefault.jpg',
    videoUrl: 'https://youtu.be/lnkJhqipwaM',
    videoEmbedUrl: 'https://www.youtube.com/embed/lnkJhqipwaM',
  },
  {
    id: 'ex-059',
    name: 'Y balance reach',
    iconUrl: 'https://img.youtube.com/vi/-SHv75OQHeo/mqdefault.jpg',
    videoUrl: 'https://youtu.be/-SHv75OQHeo',
    videoEmbedUrl: 'https://www.youtube.com/embed/-SHv75OQHeo',
  },
];

/**
 * Get all exercises sorted alphabetically by name
 */
export function getAllExercisesSorted() {
  return [...exerciseBankData].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
  );
}

/**
 * Get exercise by ID
 */
export function getExerciseById(id) {
  return exerciseBankData.find((ex) => ex.id === id);
}

/**
 * Search exercises by name
 */
export function searchExercises(query) {
  const lowerQuery = query.toLowerCase();
  return exerciseBankData
    .filter((ex) => ex.name.toLowerCase().includes(lowerQuery))
    .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
}